import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../../../constants/Settings";
import { datePickerLang } from "@/constants/globalConstants";
import ArrayHelper from "../../../common/helper/ArrayHelper";
import UserService from "@/service/UserService";
import SweetAlertService from "@/service/SweetAlertService";
import PayProfileService from "@/service/PayProfileService";
import PayMethodService from "@/service/PayMethodService";
import PayrollAdjustmentService from "@/service/PayrollAdjustmentService";
import FinalPaymentService from "@/service/FinalPaymentService";
import FinalPaymentVal from "./FinalPaymentVal.js";
import { SalayAdj } from "@/model/SalayAdj";
import { GlobalMixin } from "../../../common/mixin/GlobalMixin";
import { FinalPayment } from "@/model/FinalPayment";
const finalPaymentObj = new FinalPaymentVal();
export default {
    name: "FinalPayment",
    components: {
        DatePicker,
        moment,
    },
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
        isEng() {
            return this.$store.getters[StoreGetter.user].Lang == 'EN'
        },
        isResigned() {
            const dateResign = moment(this.selectedStaff.DateLastWork).format(Settings.DateTime.yyyymmdd);
            return dateResign < moment().format(Settings.DateTime.yyyymmdd)
        },
        staffs() {
            let list = this.staffList;
            if (this.searchRec) {
                list = list.filter((x) => ArrayHelper.wildCardSearch(x, this.searchRec))
            }
            return list
        },
        IncTypeList() {
            const list = this.incTypeList;
            const Datas = ArrayHelper.uniqueBykey(list, 'IncTypeDesc');
            return Datas
        },
    },
    data() {
        return {
            ...GlobalMixin,
            menuRights: { allRights: {}, rightsForThisMenu: {} },
            menuId: Settings.MenuID.FinalPayment,
            selectedStaff: {},
            payMethodList: [],
            incTypeList: [],
            staffList: [],
            staffFields: [
                {
                    key: "StaffID",
                    label: t.t(dictEnum.LBL_ID),
                    thStyle: { width: "30%" }
                },
                {
                    key: "EName",
                    label: t.t(dictEnum.LBL_EngName),
                    thStyle: { width: "35%" }
                },
                {
                    key: "CName",
                    label: t.t(dictEnum.LBL_ChiName),
                    thStyle: { width: "35%" }
                },
            ],
            staffFinalDetail: new FinalPayment(),
            selectedAdjustment: new SalayAdj(),
            searchRec: "",
            currentPage: 1,
            perPage: 18,
        };
    },

    mounted() {
        finalPaymentObj.FinalPaymentVal();
        this.assignRights();
        this.getPayMethodList();
        this.getIncTypeList();
    },

    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },

        rowClass(item, type) {
            if (!item || type !== "row") return;
            if (
                item.StaffID == this.selectedStaff.StaffID
            ) {
                return "selected-tr";
            }
        },

        async getStaffPerPage() {
            this.$forceUpdate();
            const tableEle = await document.getElementsByClassName("staffTable");
            const tableHeight = await tableEle[0].offsetHeight;
            const trEle = await tableEle[0].children[0].children;
            if (trEle.length > 1) {
                const thHeight = await trEle[0].offsetHeight;
                const tdHeight = await trEle[1].children[0].offsetHeight;
                let page = (tableHeight - thHeight * 2.5) / tdHeight;
                this.perPage = page.toFixed(0);
            }
        },


        async getIncTypeList() {
            const obj = {};
            const response = await PayrollAdjustmentService.getIncTypeList(obj);
            if (response) {
                this.incTypeList = response.data.Data
            }
        },

        async getPayMethodList() {
            var obj = {}
            const response = await PayMethodService.getAllPayMethod(obj);
            if (response.data.IsSuccess) {
                this.payMethodList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getStaffList() {
            var obj = {
                searchText: "",
                sortField: "",
                isInResigneUser: false
            };
            const response = await UserService.getUsers(obj);
            if (response.data.IsSuccess) {
                this.staffList = response.data.Data;
                this.getStaffPerPage();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        clickStaffTable() {
            this.$bvModal.show("StaffTable");
            this.getStaffList();
        },

        OnStaffSelect(item) {
            this.selectedStaff = JSON.parse(JSON.stringify(item));
            this.$bvModal.hide('StaffTable');
        },

        async getFinalDetail() {
            if (!this.selectedStaff.StaffID) {
                SweetAlertService.warning("Warn", t.t(dictEnum.LBL_Staff) + t.t(dictEnum.WARN_IsRequired));
                return;
            }
            if (!this.selectedStaff.DateLastWork) {
                SweetAlertService.warning("Warn", t.t(dictEnum.LBL_DateLastWork) + t.t(dictEnum.WARN_IsRequired));
                return;
            }
            const dateLastWork = moment(this.selectedStaff.DateLastWork).format(Settings.DateTime.yyyymmdd)
            const response = await FinalPaymentService.getFinalPayment(this.selectedStaff.StaffID, dateLastWork);
            if (response.data.IsSuccess) {
                this.staffFinalDetail = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message)
            }
        },

        async SubmitPayment() {
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: `${t.t(dictEnum.BTN_Submit)}`,
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                const response = await FinalPaymentService.submitFinalPayment();
                if (response.data.IsSuccess) {
                    this.getFinalDetail()
                } else {
                    SweetAlertService.warning("Warn", response.data.Message)
                }
            }
        },

        async DeletePayment() {
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: `${t.t(dictEnum.WARN_Delete)}`,
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                const response = await FinalPaymentService.delFinalPayment();
                if (response.data.IsSuccess) {
                    this.getFinalDetail()
                } else {
                    SweetAlertService.warning("Warn", response.data.Message)
                }
            }
        },

        async SavePayment() {
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: `${t.t(dictEnum.CFM_Save)}`,
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                const response = await FinalPaymentService.saveFinalPayment();
                if (response.data.IsSuccess) {
                    this.getFinalDetail()
                } else {
                    SweetAlertService.warning("Warn", response.data.Message)
                }
            }
        },

        async PrintPayment() {
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: `${t.t(dictEnum.LBL_Print)}`,
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) { }
        },

        TotalAL() {
            const total =
                this.staffFinalDetail.AtuSalary +
                this.staffFinalDetail.AnnualLeaveTotal;
            return total;
        },

        TotalCL() {
            const alTotal = this.TotalAL();
            return alTotal + this.staffFinalDetail.CompensationLeaveTotal
        },

        Balance(index) {
            let LeaveBal = this.TotalCL();
            let num = 0;
            if (this.staffFinalDetail.salaryAdjs.length > 0) {
                const list = this.staffFinalDetail.salaryAdjs.filter((x, i) => i <= index)
                for (let data of list) {
                    const amt = Number(data.Amt)
                    if (data.AdjAdd) {
                        num += amt
                    } else {
                        num -= amt
                    }
                }
            }
            num += LeaveBal;
            return num
        },

        AddAdjustment() {
            this.$bvModal.show("Adjustment");
            const data = new SalayAdj();
            data.StaffID = this.staffFinalDetail.StaffID;
            this.selectedAdjustment = data;
        },

        editAdjustment(item) {
            this.$bvModal.show("Adjustment");
            const data = JSON.parse(JSON.stringify(item));
            data.DateTx = moment(data.DateTx).format(Settings.DateTime.yyyymmdd);
            this.selectedAdjustment = data;
        },

        async deleteAdjustment(item) {
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: `${t.t(dictEnum.WARN_Delete)}?`,
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                const obj = {
                    staffID: item.StaffID,
                    date: moment(item.DateTx).format(Settings.DateTime.yyyymmdd),
                    seq: item.Seq
                }

                const response = await PayrollAdjustmentService.deletePayAdj(obj);
                if (response.data.IsSuccess) {
                    SweetAlertService.success("Success", response.data.Message);
                    this.getFinalDetail();
                } else {
                    SweetAlertService.warning("Warn", response.data.Message)
                }
            }
        },

        changeIncType(e) {
            this.selectedAdjustment.IncSubType = "";
        },

        AddOrUpdateAdjustment() {
            this.$validator.validateAll().then(async result => {
                if (result) {
                    this.$bvModal.hide("Adjustment");
                    const obj = {
                        model: this.selectedAdjustment
                    }
                    const response = await PayrollAdjustmentService.savePayAdj(obj);
                    if (response.data.IsSuccess) {
                        SweetAlertService.success("Success", response.data.Message);
                        this.getFinalDetail();
                    } else {
                        SweetAlertService.warning("Warn", response.data.Message);
                    }
                }
            });
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/100000-Payroll/105000-FinalPayment/105000-FinalPayment.js